import { connectStats } from 'instantsearch.js/es/connectors';
import { updateDataLayer } from '../../dataLayerEnrichment';

const searchResultText = document.querySelector('#algoliaStats');

const renderStats = (renderOptions, isFirstRender) => {
	if (isFirstRender) return;

	const { nbHits, query } = renderOptions;
	let searchResultMainHeading = '';
	let searchResultIntro = '';
	const text = searchResultText?.dataset;

	updateDataLayer(nbHits, query);

	switch (nbHits) {
		case 0:
			searchResultMainHeading = `${text?.searchNoResultsMainHeading}`;
			searchResultIntro = `${text?.searchNoResultsIntro} '${query}'.`;
			break;
		default:
			searchResultMainHeading = `<span class="sr-only">
					${text?.searchResultsMainHeading}
				</span> 
				"${query}"
				<span class="algolia-search-list-page__count">
					(${nbHits}<span class="sr-only">${text?.statProductMsg}</span>)
				</span>`;
			searchResultIntro = '';
	}
	// TODO: Determine if using 'id' would be better to target HTML elements rather than class names for the algolia widgets
	document.querySelector('.algolia-search-list-page__main-heading').innerHTML =
		searchResultMainHeading;
	document.querySelector('.algolia-search-list-page__intro').innerText =
		searchResultIntro;
};

// Create custom stats widget
const customStats = connectStats(renderStats);

export const customStatsWidget = customStats({
	container: searchResultText,
});
